import React from 'react';
import ProductViewTemplate from '@/components/partials/ProductView/ProductViewTemplate';
import { ProductViewModes } from '@/utils/productStateUtils';
import { useProductChangeRequestRO } from '@/components/partials/ProductView/ProductChangeRequestRO/useProductChangeRequestRO';

const ProductChangeRequestRO = () => {
  const viewHook = useProductChangeRequestRO();

  return (
    <ProductViewTemplate
      productViewMode={ProductViewModes.ChangeRequestReadOnly}
      viewHook={viewHook}
    />
  );
};

export default ProductChangeRequestRO;
